var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99988 1.59998C8.35334 1.59998 8.63988 1.88651 8.63988 2.23998V10.56C8.63988 10.9134 8.35334 11.2 7.99988 11.2C7.64642 11.2 7.35988 10.9134 7.35988 10.56V2.23998C7.35988 1.88651 7.64642 1.59998 7.99988 1.59998Z",
    fill: "#21272F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.98733 7.54743C5.23727 7.29749 5.6425 7.29749 5.89243 7.54743L7.99988 9.65488L10.1073 7.54743C10.3573 7.29749 10.7625 7.29749 11.0124 7.54743C11.2624 7.79736 11.2624 8.20259 11.0124 8.45252L8.45243 11.0125C8.2025 11.2625 7.79727 11.2625 7.54733 11.0125L4.98733 8.45252C4.7374 8.20259 4.7374 7.79736 4.98733 7.54743Z",
    fill: "#21272F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.51988 11.2C3.87335 11.2 4.15988 11.4865 4.15988 11.84V13.12H11.8399V11.84C11.8399 11.4865 12.1264 11.2 12.4799 11.2C12.8333 11.2 13.1199 11.4865 13.1199 11.84V13.12C13.1199 13.8269 12.5468 14.4 11.8399 14.4H4.15988C3.45296 14.4 2.87988 13.8269 2.87988 13.12V11.84C2.87988 11.4865 3.16642 11.2 3.51988 11.2Z",
    fill: "#21272F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIconBlack);
export default __webpack_public_path__ + "static/media/download-icon-black.0cfc61aa2d3231dd4ee15911be736f81.svg";
export { ForwardRef as ReactComponent };